export default {
  check_status: {
    verified: 'Verificat',
    pending: 'În așteptare',
    failed: 'Eșuat',
    not_applicable: 'Nu este necesar',
    required: 'Obligatoriu',
  },
  records: {
    type: 'Tip',
    name: 'Nume',
    value: 'Valoare',
    status: 'Stare',
    certificate: 'Certificat',
    certificate_hint: 'Emis automat de îndată ce înregistrările de mai sus sunt găsite.',
    full_name: 'Nume complet:',
  },
  check_hint: {
    found: 'S-a găsit {{values}} în loc. Înlocuiți-l cu valoarea afișată.',
    missing: 'Această înregistrare nu a fost găsită.',
    certificate: 'Certificatul nu a putut fi emis. Corectați înregistrările marcate mai sus, apoi verificați din nou.',
    certificate_unknown:
      'Certificatul nu a putut fi emis. Verificați din nou mai târziu și contactați asistența dacă situația persistă.',
    regressed: 'Această înregistrare a fost verificată anterior și nu mai este găsită.',
    technical: 'Detaliu tehnic: {{error}}',
    held_by_another_project:
      '{{name}} este folosit de un alt site web pe Vercel, așa că nu poate redirecționa vizitatorii către magazinul de pe www.{{name}}. Pentru ca și {{name}} să deschidă magazinul, eliminați mai întâi domeniul de pe celălalt site web.',
    certificate_pending: {
      not_attached: 'În curs: adăugăm domeniul din partea noastră.',
      awaiting_dns: 'În curs: certificatul este emis de îndată ce înregistrările de mai sus sunt găsite.',
      awaiting_certificate:
        'În curs: înregistrările indică spre noi, iar certificatul este în curs de emitere. De obicei durează câteva minute.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} este conectat și la un alt cont Vercel. Pentru a dovedi că vă aparține, adăugați și înregistrările TXT de mai jos la furnizorul DNS, apoi verificați din nou.',
      held_by_another_project:
        'Un alt site web pe Vercel folosește deja {{name}}. Eliminați mai întâi domeniul de pe acel site web, apoi verificați din nou — sau folosiți alt domeniu.',
      dns_correct_but_unconfigured:
        'Înregistrările de mai sus sunt corecte, dar altceva de pe {{name}} blochează certificatul. Eliminați orice înregistrare AAAA de pe acest nume, dezactivați orice proxy din fața lui (cum ar fi norul portocaliu din Cloudflare) și asigurați-vă că nicio înregistrare CAA nu exclude Let’s Encrypt. Apoi verificați din nou.',
      name_mismatch:
        '{{name}} răspunde cu un certificat pentru {{names}}. Asigurați-vă că înregistrările de mai sus sunt singurele de pe {{name}}; dacă da, contactați asistența.',
      name_mismatch_unnamed:
        '{{name}} răspunde cu un certificat pentru alt nume. Asigurați-vă că înregistrările de mai sus sunt singurele de pe {{name}}; dacă da, contactați asistența.',
      expired:
        'Certificatul a expirat și nu a fost reînnoit. Am fost alertați și ne ocupăm de asta — deocamdată nu trebuie să faceți nimic.',
      expiring:
        'Certificatul expiră în curând și nu a fost încă reînnoit. Ne ocupăm de asta — deocamdată nu trebuie să faceți nimic.',
      attach_refused:
        'Furnizorul nostru de găzduire a refuzat să adauge {{name}} din partea noastră. Am fost anunțați și verificăm — deocamdată nu trebuie schimbat nimic la furnizorul DNS.',
    },
    certificate_overdue: {
      not_attached: 'După 48 de ore, domeniul tot nu a putut fi adăugat din partea noastră. Contactați asistența.',
      awaiting_dns:
        'Încă se așteaptă înregistrările de mai sus după 48 de ore. Corectați înregistrările marcate mai sus, apoi verificați din nou.',
      awaiting_dns_records_verified:
        'Încă neemis după 48 de ore, deși înregistrările de mai sus sunt verificate. Contactați asistența.',
      awaiting_certificate:
        'Înregistrările indică spre noi, dar certificatul tot nu a fost emis după 48 de ore. Contactați asistența.',
    },
    certificate_dates: {
      valid_until: 'Valabil până la {{date}}.',
      expires_on: 'Expiră pe {{date}}.',
      expired_on: 'A expirat pe {{date}}.',
    },
  },
};
